import { render, staticRenderFns } from "./SectionCriteria.vue?vue&type=template&id=5b33f6a1&scoped=true"
import script from "./SectionCriteria.vue?vue&type=script&lang=js"
export * from "./SectionCriteria.vue?vue&type=script&lang=js"
import style0 from "./SectionCriteria.vue?vue&type=style&index=0&id=5b33f6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33f6a1",
  null
  
)

export default component.exports